module.exports = __webpack_public_path__ + "static/media/mediation-inactive.8aa24e79.svg";